import { render, staticRenderFns } from "./widget-setting-method.vue?vue&type=template&id=05fe718e"
import script from "./widget-setting-method.vue?vue&type=script&lang=js"
export * from "./widget-setting-method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports